export default __webpack_public_path__ + "locales/lo-LA/HotkeysPanel.json?hash=42706111d26936a4b80a2ed669e03b21";